import React, {useState} from "react";
import Header from "../../main/Header/Header";
import AgencySidebar from "../../main/AgencySidebar/AgencySidebar";

const AgencyLayout = ({ children }) => {
    
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    return (
        <div className='w-full h-full'>
            <Header onMenuToggle={toggleMobileMenu}/>
            <div className='flex justify-between h-[90%]'>
                <AgencySidebar  isOpen={isMobileMenuOpen} 
                onClose={() => setIsMobileMenuOpen(false)} />
                {children}
            </div>
        </div>
    )
};

export default AgencyLayout;
